import React, { useRef, useState } from 'react'
import logo from '../../assets/Logo.svg'
import { FiMenu, FiX } from 'react-icons/fi'
import './Navbar.scss';
import { useTranslation } from 'react-i18next';
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

type LngRet = { [lng: string]: { nativeName: string; }; }

const langs: LngRet = {
  en: { nativeName: 'en' },
  ua: { nativeName: 'ua' },
  ru: { nativeName: 'ru' }
};

gsap.registerPlugin(useGSAP);

const Navbar = () => {
  const { i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;
  const [toggle, setToggle] = useState(false);
  const links = {
    en: ["home", "about", "skills", "works", "contacts"],
    ua: ["на початок", "про мене", "навички", "роботи", "контакти"],
    ru: ["в начало", "обо  мне", "навыки", "работы", "контакты"]
  };
  const [currentLang, setCurrentLang] = useState(i18n.resolvedLanguage);
  let currentLinks: string[] = links.en;
  for (const [key, value] of Object.entries(links)) {
    if (key === lang) {
      currentLinks = value;
    }
  }
  const container = useRef(null);

  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    const href = e.currentTarget.getAttribute('href');
    if ( !href ) return;
    const element = document.getElementById(href.replace('#', ''));
    if ( !element ) return;
    window.scroll({
      top: element.offsetTop - 20,
      behavior: 'smooth'
    });
  };

  useGSAP(() => {
    gsap.fromTo(".gsap-show", {
      x: '-100%',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      ease: "slow",
      stagger: 0.1
    });
  }, { scope: container });
  
  return (
    <nav className="navbar" ref={container}>
      <div className="navbar__logo gsap-show">
        <img src={`${logo}`} alt="Pensativa logo" width={150} height={36} />
      </div>
      <ul className={`navbar__menu open-${toggle}`}>
        {currentLinks ? (currentLinks.map((item, i) => (
          <li 
            key={`top-${item}`} 
            className='gsap-show'
          >
            <a 
              href={`#${links.en[i]}`}
              onClick={(e) => scrollTo(e)}
            >
                <span>#</span>{item}
            </a>
          </li>
        ))) : (null)}
      </ul>
      <label className='hidden' htmlFor={lang}>Choose your language</label>
      <select
        id={lang}
        className='lang-dropdown gsap-show'
        value={currentLang}
        onChange={(e) => {
          i18n.changeLanguage(e.target.value)
          setCurrentLang(e.target.value);
        }}
      >
          {Object.keys(langs).map((lng) => (
            <option key={lng} value={lng}>
               {langs[lng].nativeName}
            </option>
          ))}
      </select>

      <div className="navbar__burger">
        <div className={`navbar__toggle navbar__toggle--${toggle}`}>
          {toggle ? (
            <FiX
              onClick={() => setToggle(false)}
            />) : (
              <FiMenu
                onClick={() => setToggle(true)}
              />
            )}
          </div>
      </div>
    </nav>
  );
}

export default Navbar